var _linearGradient, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "quote_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: -914.32,
    y1: 554.72,
    x2: -915.32,
    y2: 555.72,
    gradientTransform: "matrix(50 0 0 -50 45766 27786)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f92ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#833ee4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7750"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#quote_svg__a)",
    d: "M10 0h30c5.523 0 10 4.477 10 10v30c0 5.523-4.477 10-10 10H10C4.477 50 0 45.523 0 40V10C0 4.477 4.477 0 10 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M38.634 14.273c-1.127 1.122-2.155 2.469-3.085 4.04-.93 1.571-1.535 3.143-1.817 4.714 2.085 0 3.817.589 5.197 1.768 1.38 1.178 2.07 2.834 2.07 4.966 0 2.076-.634 3.802-1.901 5.177S36.183 37 34.155 37s-3.676-.715-4.944-2.146-1.901-3.185-1.901-5.261c0-3.479.845-6.832 2.535-10.059 1.69-3.227 3.831-5.738 6.423-7.534l2.366 2.273zm-16.31 0c-1.127 1.122-2.155 2.469-3.085 4.04-.93 1.571-1.535 3.143-1.817 4.714 2.085 0 3.817.589 5.197 1.768s2.07 2.834 2.07 4.966c0 2.076-.634 3.802-1.901 5.177S19.873 37 17.845 37s-3.676-.715-4.944-2.146S11 31.669 11 29.593c0-3.479.845-6.832 2.535-10.059s3.831-5.738 6.423-7.534l2.366 2.273z"
  })));
};
export default SvgQuote;